<template>
  <div class="div_title">
    <context :context=cate />
  </div>
  <div class="card" >
    <read page='tip'/>
  </div>
  <div class="ad-container">
    <Adsense
      data-ad-client="ca-pub-6699354447815429" 
      data-ad-slot="8230887469"
      data-ad-format="horizontal"
      data-full-width-responsive="true">
    </Adsense>
  </div>
</template>
<script>

import { ref, inject } from 'vue'
import context from '@/components/common/Context.vue'
import ssr from './components/common/ssr'
import read from '@/Read.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const setMeta = inject('setMeta')
    const title = 'GEEK9 > 꿀팁'
    const keywords = '꿀팁, 팁, tip, 노하우, 물류정보, 직구정보, 해외직구 노하우, 해외직구하는 방법'
    const description = '알아두면 돈되는 개인해외직구,기업물류 관련 팁!'
    const geek9Url = ssr.GEEK9_URL + 'tip'
    const { t } = useI18n()

    setMeta({
      title: title,
      keywords: keywords,
      description: description,
      'og:title': title,
      'og:description': description,
      'og:image': 'https://geek9.kr/img/favicon.png',
      'og:url': geek9Url,
      'canonical': geek9Url
    })
    const addJsonLd = () => {
      let flag = true
      document.querySelectorAll('script').forEach(el => {
        if (el.getAttribute('type') === 'application/ld+json' ) {
          flag = false
          return
        }
      })
      if(flag === true) {
        const script = document.createElement('script')
        script.setAttribute('type', 'application/ld+json')
        script.textContent = JSON.stringify(
          {
            "@context": "https://schema.org",
            "@graph": [
              ssr.getWebPage(geek9Url, title, ssr.GEEK9_URL, description),
            ]
          }
        )
        document.head.appendChild(script)
      }
    }
    const expandedRows = ref({})
    const cate = ref([
      { label: `${t('menu.board')}`, route:'https://contents.geek9.kr' },
      { label: `${t('menu.tip')}`, route: '/tip' }
    ])
    return {
      expandedRows, cate, addJsonLd
    }
  },
  components: {
    context, read
  },  
  mounted() {
    this.addJsonLd()
    this.api.setPage('tip')
    this.$emit("setMenu", {page:'tip'})
    console.log(this.api.getCookies('page'))
  },
  data() { 
    return { 
      tipKey:-1,
      tipKeyword:undefined,
      idx : '-1',
      page:1,
      tipList: Array(),
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.datatable-background {
  background-color:#f9f9f9;
}
</style>